/* eslint-disable @typescript-eslint/no-explicit-any */
import css from '@styled-system/css';
export var truncateProp = function truncateProp(_ref) {
  var truncated = _ref.truncated;

  if (truncated) {
    return {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    };
  }
};
export var visuallyHiddenProp = function visuallyHiddenProp(_ref2) {
  var visuallyHidden = _ref2.visuallyHidden;

  if (visuallyHidden) {
    return {
      border: '0px',
      height: '1px',
      width: '1px',
      margin: '-1px',
      padding: '0px',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      position: 'absolute'
    };
  }
};
export var sxProp = function sxProp(props) {
  return css(props.sx)(props);
};